import React, { useState, createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { backend } from '../../components/apipath';

const AuthContext = createContext({
    authorized: false,
    id: 0,
    mem_id: 0,
    account: "",
    token: "",
    name: "",
    type: "",
    chinese_name: "",
    mem_status: "",
});

export const AuthProvider = ({ children }) => {
    const unAuthState = {
        authorized: false,
        id: 0,
        mem_id: 0,
        account: "",
        token: "",
        name: "",
        type: "",
        chinese_name: "",
    };

    const isAdminPath = window.location.pathname.startsWith('/adm');
    const localStorageKey = isAdminPath ? 'authAdm' : 'auth';
    const initialAuthState = { ...unAuthState };

    const localAuthStr = localStorage.getItem(localStorageKey);
    let localAuth = { ...initialAuthState };
    if (localAuthStr) {
        try {
            localAuth = JSON.parse(localAuthStr);
            if (localAuth.account && localAuth.token) {
                localAuth.authorized = true;
            }
        } catch (ex) {
            console.error('Error parsing auth data:', ex);
        }
    }

    const [auth, setAuth] = useState(localAuth);
    const navigate = useNavigate();

    const logout = async () => {
        try {
            await fetch(`${backend}login/logout`, {
                method: 'POST',
                credentials: 'include'
            });
        } catch (error) {
            console.error("登出錯誤:", error);
        }
    
        localStorage.removeItem(localStorageKey); // 如果你還有存 authAdm
        setAuth({ ...initialAuthState });
        navigate(isAdminPath ? '/adm/admlogin' : '/');
    };

    return (
        <AuthContext.Provider value={{ ...auth, setAuth, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);